import { all, put, takeEvery, call, select } from 'redux-saga/effects';
import { URLS } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import { popModal } from './basicActions';
import { pushBadgeModal, confirmYes, confirmNo, doNotShowAgainChanged } from './actionCreators';
import { closeNotificationsDropdown } from '../../SiteHeader/redux/actions';
import { messageReceived } from '../../redux/messages/action';
import { createOrOpenChatWithUser } from '../../Chat/redux/actions';
import { getCurrentModal } from './selectors';
import { getCompliantLocalStorageItem } from '../../redux/compliantLocalStorage/selectors';
import { CompliantLocalStorageKeys } from '../../redux/compliantLocalStorage/constants';
import { setCompliantLocalStorageItem } from '../../redux/compliantLocalStorage/actions';
function* handleBadgeModal(message) {
    let isInsideIframe;
    try {
        isInsideIframe = window.self !== window.top;
    } catch (e) {
        isInsideIframe = true;
    }
    // badge modal could be fired from the recent messages iframe in header
    if (isInsideIframe) {
        return;
    }
    if (message.badgeName && message.userId) {
        ddt.log('shared', 'firing pushBadgeModal', message);
        yield put(pushBadgeModal(message.username, message.onBadgeSent, message.onClose));
    }
}
function* handleGiveModal(message) {
    if (message.command === 'badge_receipt') {
        // Relay the message to the notifications iframe too
        const iframe = document.getElementById('eclipse-notifications-iframe');
        if (iframe && iframe.contentWindow) {
            // Notifications iframe is always hosted on www.deviantart.com
            // so target origin is URLS.ROOT
            iframe.contentWindow.postMessage(JSON.stringify(message), URLS.ROOT);
        }
    }
}
function* handleMessage({ payload: message  }) {
    switch(message.type){
        case 'OpenBadgeModal':
            yield call(handleBadgeModal, message);
            break;
        case 'GiveModal':
            yield call(handleGiveModal, message);
            break;
        case 'OpenChat':
            yield put(createOrOpenChatWithUser(`window-message-${message.user.useridUuid}`, message.user));
            if (message.source && message.source === 'messagecentre') {
                yield put(closeNotificationsDropdown());
            }
            break;
        default:
    }
}
function* handleConfirmAnswer() {
    var _modal_options, _modal_options_params, _modal_options1, _modal_options_params1;
    const modal = yield select(getCurrentModal);
    if ((modal === null || modal === void 0 ? void 0 : (_modal_options = modal.options) === null || _modal_options === void 0 ? void 0 : (_modal_options_params = _modal_options.params) === null || _modal_options_params === void 0 ? void 0 : _modal_options_params.closeOnConfirmation) === false) {
        return;
    }
    yield put(popModal());
    if (modal === null || modal === void 0 ? void 0 : (_modal_options1 = modal.options) === null || _modal_options1 === void 0 ? void 0 : (_modal_options_params1 = _modal_options1.params) === null || _modal_options_params1 === void 0 ? void 0 : _modal_options_params1.onClose) {
        var _modal_options2, _modal_options_params2;
        modal === null || modal === void 0 ? void 0 : (_modal_options2 = modal.options) === null || _modal_options2 === void 0 ? void 0 : (_modal_options_params2 = _modal_options2.params) === null || _modal_options_params2 === void 0 ? void 0 : _modal_options_params2.onClose();
    }
}
function* handleDoNotShowAgainChanged(action) {
    try {
        const dnsDb = yield select(getCompliantLocalStorageItem, CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN);
        let dnsItems;
        if (!dnsDb) {
            dnsItems = {
                [action.payload.key]: action.payload.value
            };
            yield put(setCompliantLocalStorageItem({
                key: CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN,
                value: JSON.stringify(dnsItems)
            }));
            return;
        }
        dnsItems = JSON.parse(dnsDb);
        dnsItems[action.payload.key] = action.payload.value;
        yield put(setCompliantLocalStorageItem({
            key: CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN,
            value: JSON.stringify(dnsItems)
        }));
    } catch (e) {
        const dnsItems1 = {
            [action.payload.key]: action.payload.value
        };
        yield put(setCompliantLocalStorageItem({
            key: CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN,
            value: JSON.stringify(dnsItems1)
        }));
    }
}
export default function* saga() {
    yield all([
        takeEvery(messageReceived, handleMessage),
        takeEvery(confirmYes, handleConfirmAnswer),
        takeEvery(confirmNo, handleConfirmAnswer),
        takeEvery(doNotShowAgainChanged, handleDoNotShowAgainChanged)
    ]);
}
